export default function RunIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.635 11.6547C19.6123 11.1936 19.3455 10.641 18.6963 10.1815C17.4823 9.32223 15.7875 8.21307 13.5 6.89239C12.0632 6.06285 10.8315 5.4033 9.79179 4.8805C8.81812 4.39092 7.92342 4.48173 7.27761 4.87841C6.62608 5.27859 6.11771 6.05884 6.07574 7.16618C6.03031 8.36525 6 9.8088 6 11.5263C6 13.6382 6.04583 15.3359 6.10926 16.6741C6.15546 17.6489 6.57745 18.317 7.09496 18.6578C7.59974 18.9903 8.31961 19.0952 9.17024 18.702C10.4129 18.1277 12.0026 17.3135 14 16.1603C16.2271 14.8745 17.779 13.8497 18.8545 13.0609C19.4614 12.6158 19.6569 12.099 19.635 11.6547ZM19.4459 13.8673C21.1341 12.6291 20.9829 10.5748 19.274 9.36526C18.0331 8.48693 16.3121 7.36128 14 6.02636C12.5477 5.18789 11.2991 4.51911 10.241 3.98708C7.72224 2.7206 5.18322 4.31108 5.07646 7.12832C5.03051 8.34088 5 9.79708 5 11.5263C5 13.6526 5.04614 15.3661 5.11038 16.7214C5.22853 19.2141 7.32447 20.6567 9.58975 19.6098C10.8639 19.021 12.4806 18.1923 14.5 17.0264C16.751 15.7268 18.3347 14.6823 19.4459 13.8673Z"
          fill="white"
        />
      </svg>
    </>
  );
}
